import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseInventoryIssueActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/InventoryIssue/InventoryIssueBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseInventoryIssue"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseInventoryIssue"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseInventoryIssueActivity)
